import { useStore } from "vuex";
import { useRouter } from "vue-router";

export const useUser = () => {
  const router = useRouter();
  const store = useStore();

  const getUser = async () => {
    try {
      await store.dispatch("auth/getUserToken");
    } catch (e) {
      console.log("i have errors");
      router.push({ name: "login" });
    }
  };

  return {
    getUser,
  };
};
